module.exports = __webpack_public_path__ + "media/images/icons/flags/ST-d8c2afba5427aa175bba1f9620c7bef8.svg";